import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import request from '../helpers/request';

const getRequestStreetsByServiceCompany = async (serviceCompanyIds) => {
  const res = await request.get(
    '/Request/service_companies_streets',
    { serviceCompanyIds },
    'Не удалось загрузить улицы',
    []
  );
  return res;
};

const useRequestStreetsByServiceCompany = ({ serviceCompanyIds }, options) =>
  useQuery(
    queryKeys.requestStreetsByServiceCompany(serviceCompanyIds),
    () => getRequestStreetsByServiceCompany(serviceCompanyIds),
    options
  );

export default useRequestStreetsByServiceCompany;
